// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"PageTitle_pageTitle__1Iuxc"};